import React from 'react'
import { Box, Typography, Link, Divider } from '@mui/material'
import './footer.css'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'

const Footer = () => (
  <>
    <Divider orientation='vertical' flexItem sx={{ color: 'white', border: '1px solid' }} />
    <Box className="footer-container">
      <Box className="footer-content">
        {/* Contact Details */}

        <Box className="footer-left">
          <Box className="footer-contact-item">
            <LocationOnIcon className="footer-icon" />
            <Typography variant="body1" className="footer-text">
              Basingstoke, Hampshire
            </Typography>
          </Box>

          <Box className="footer-contact-item">
            <EmailIcon className="footer-icon" />
            <Typography variant="body1" className="footer-text">
              info@pulsepallets.co.uk
            </Typography>
          </Box>

          <Box className="footer-contact-item">
            <PhoneIcon className="footer-icon" />
            <Typography variant="body1" className="footer-text">
              07862 079920
            </Typography>
          </Box>
        </Box>

        {/* Copyright */}

        <Box className="footer-right">
          <Typography variant="body1" className="footer-text">
            &copy; {new Date().getFullYear()} Pulse Pallets. All rights reserved.
          </Typography>

          <Typography variant="body1" className="footer-text">
            Developed and maintained by{' '}
            <Link
              href="https://www.kaizen-web.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              Kaizen Development
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  </>
)

export default Footer
